export const OVERALL_RATING_TITLE = 'Overall Rating'
export const YOUR_CHANGE_TITLE = 'YOUR CHANGE'
export const TEAM_CHANGE_TITLE = 'TEAM CHANGE'
export const REVIEWER_RATINGS_TITLE = 'Reviewer Ratings'

export const NA = 'N/A'
